// MAIN
const METRIKA_ID = 104645311;

// // DEV / TEST
// const METRIKA_ID = 106139984;

export const metrikaGoal = (goal: string, params?: Record<string, any>) => {
    console.log('[METRIKA GOAL]', goal, params);

    if (typeof window === 'undefined') return;
    if (!(window as any).ym) return;

    (window as any).ym(METRIKA_ID, 'reachGoal', goal, params);
};
